import { BrandfetchIcon } from "@editor/modules/media-lib/icons";
import type {
  IMediaLibDialogItem,
  TElement,
} from "@editor/modules/media-lib/types";
import { useResetStore } from "../hooks";
import { useLogosStoreShallow } from "../store";
import type { IMediaLibLogo } from "../types";
import { LogoFinderContainer } from "./logo-finder-container";
import { LogoFinderSearchInput } from "./logo-finder-search-input";

export const LogoFinder = ({
  elementWrapper,
  view,
  onSelect,
  selectedItems,
  isMultiSelect,
}: {
  elementWrapper?: React.ComponentType<{
    children: React.ReactNode;
    element: TElement;
  }>;
  view?: "panel" | "dialog";
  onSelect?: (item: IMediaLibLogo) => void;
  selectedItems?: IMediaLibDialogItem[];
  isMultiSelect?: boolean;
}) => {
  useResetStore();
  const {
    setSearchQuery,
    logosData,
    updateLogoData,
    brand,
    setLogosData,
    setBrand,
  } = useLogosStoreShallow((s) => ({
    setSearchQuery: s.setQuery,
    logosData: s.logosData,
    updateLogoData: s.updateLogoData,
    brand: s.brand,
    setLogosData: s.setLogosData,
    setBrand: s.setBrand,
  }));

  return (
    <div className="tw-relative tw-grid tw-h-full tw-grid-rows-[auto_auto_1fr] tw-overflow-hidden">
      <div className="tw-grid tw-max-w-full tw-px-6 tw-pb-6 tw-pt-0.5">
        <LogoFinderSearchInput />
      </div>

      <LogoFinderContainer
        className="scrollbar tw-w-[calc(100%-6px)] tw-overflow-y-scroll tw-overscroll-contain tw-pb-6 tw-pl-6 tw-pr-3 tw-pt-1"
        brand={brand}
        logosData={logosData}
        setLogosData={setLogosData}
        updateLogoData={updateLogoData}
        setBrand={setBrand}
        setSearchQuery={setSearchQuery}
        elementWrapper={elementWrapper}
        view={view}
        onSelect={onSelect}
        selectedItems={selectedItems}
        isMultiSelect={isMultiSelect}
      />
      <div
        className="tw-absolute tw-bottom-2 tw-right-2 tw-flex tw-h-8 tw-max-w-24 tw-items-center tw-justify-center tw-rounded-[40px] tw-bg-white tw-px-3 tw-py-2 tw-transition-colors"
        style={{
          boxShadow:
            "0px 0px 0px 1px rgba(18, 3, 62, 0.06), 0px 5px 1px 0px rgba(18, 3, 62, 0.00), 0px 3px 1px 0px rgba(18, 3, 62, 0.01), 0px 2px 1px 0px rgba(18, 3, 62, 0.03), 0px 1px 1px 0px rgba(18, 3, 62, 0.04)",
        }}
      >
        <BrandfetchIcon className="tw-size-auto" />
      </div>
    </div>
  );
};
